import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import { GET_DEPOTS } from 'Util/queries';
const { Option } = Select;

function DepotsDropDown({ onChange, form, value, ...rest }) {

    const { data, loading } = useQuery(GET_DEPOTS, {
        variables: {
            where: {
                deleted_at: { _is_null: true },
                active: { _eq: true }
            }
        },
    });

    const list = data?.depots ?? [];

    const handleChange = (v) => {
        const selected = list.find(item => item.id === v);
        if (form && selected) {
            form.setFieldsValue({
                depot_id: selected.id,
                depot_name: selected.name,
                depot_code: selected.code,
            });
        }
        if (onChange) onChange(v);
    };

    return (
        <Select
            {...rest}
            value={value}
            loading={loading}
            placeholder="Select a depot"
            onChange={handleChange}
        >
            {list.map(v => <Option value={v.id} key={`depots-dd-opt${v.id}`}>{v.name}</Option>)}
        </Select>
    )
}

export default DepotsDropDown
